module.exports = __webpack_public_path__ + "img/13.d2d8378a.png";